import { ClaimDirectDepositRequest, ClaimPhysicalCardRequest } from '@bybeam/platform-types';
import FieldDetail from '@platform-ui-common/components/FieldDetail/index.js';
import { camelCaseToSpace } from '@platform-ui-common/utilities/format.js';
import { AccountTypesDisplay } from '@platform-ui-common/utilities/payment.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import { ClaimPayload } from '@platform-ui/claim/hooks/useClaim.js';
import AddressReview from './AddressReview.js';

export enum ReviewBoxType {
  MailingAddress = 'address',
  EmailAddress = 'email',
}

type ReviewBoxProps = {
  type?: ReviewBoxType;
  payload: ClaimPayload;
};

function ReviewBox({ type, payload }: ReviewBoxProps): JSX.Element {
  const { user } = useAuth();
  switch (type) {
    case ReviewBoxType.MailingAddress:
      return <AddressReview address={(payload as ClaimPhysicalCardRequest).address} />;
    case ReviewBoxType.EmailAddress:
      return (
        <>
          <FieldDetail label="Email Address">
            <span className="break-all">{user?.core?.email ?? 'n/a'}</span>
          </FieldDetail>
        </>
      );
    default:
      return (
        <>
          {Object.entries((payload as ClaimDirectDepositRequest).bankAccount).map(
            ([key, value]) => (
              <FieldDetail key={key} label={camelCaseToSpace(key)}>
                {key === 'accountType' ? AccountTypesDisplay[value] : value}
              </FieldDetail>
            ),
          )}
        </>
      );
  }
}

export default ReviewBox;
